<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <div class="level">
        <div class="level-left">
          <h1 class="title is-5">{{ employeeGanttData.employee__initials }}</h1>
        </div>
        <div class="level-right">
          <div class="control">
            <!--<button class="button is-success">Распечатать</button>-->
          </div>
        </div>
      </div>
      <div class="level">
        <div class="level-left">
          <div class="field controls is-grouped">
            <div class="control">
              <b-field :label="$t('reports.date')">
                <b-datepicker v-model="date"
                              @input="loadData"
                              :month-names="$locale.datePicker().month"
                              :day-names="$locale.datePicker().days"
                              icon="calendar-today">
                </b-datepicker>
              </b-field>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="field controls is-grouped">
            <div class="control">
              <span class="stats">
                <span>{{ employeeGanttData.in_process_tasks_count }}</span>
                <small class="has-text-weight-normal">{{ $t('reports.userStats.progress') }}</small>
              </span>
            </div>
            <div class="control">
              <span class="stats">
                <span>{{ employeeGanttData.closed_tasks_count }}</span>
                <small class="has-text-weight-normal">{{ $t('reports.userStats.done') }}</small>
              </span>
            </div>
            <div class="control">
              <span class="stats">
                <span>{{ employeeGanttData.expired_tasks_count }}</span>
                <small class="has-text-weight-normal">{{ $t('reports.userStats.expired') }}</small>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div ref="ganttChart" v-show="employeeGantt[0].data.length > 0" class="chart"></div>
      <section v-if="employeeGantt[0].data.length === 0" class="section">
        <div class="content is-fluid has-text-grey has-text-centered">
          <p>{{ $t('reports.noDataAtSelectedDate') }}</p>
        </div>
      </section>
    </div>
  </DashboardLayout>
</template>

<script>
  import DashboardLayout from '@/components/DashboardLayout'
  import Highcharts from '@/highcharts'
  import {mapState, mapGetters} from 'vuex'
  import {prepareDate} from '@/utils'

  export default {
    components: {
      DashboardLayout
    },
    data() {
      return {
        date: new Date(),
        employeeId: null
      }
    },
    methods: {
      loadData() {
        this.$store.dispatch('Reports/getEmployeeGantt', {
          date: prepareDate(this.date),
          employee_id: this.employee
        }).then(() => this.$nextTick(this.drawCharts()))
      },
      drawCharts() {
        let series = [...this.employeeGantt],
            dateFormat = Highcharts.dateFormat,
            defined = Highcharts.defined,
            isObject = Highcharts.isObject,
            reduce = Highcharts.reduce

        Highcharts.ganttChart(this.$refs.ganttChart, {
          series,
          tooltip: {
            pointFormatter: function () {
              let point = this,
                format = '%e. %b',
                options = point.options,
                completed = options.completed,
                amount = isObject(completed) ? completed.amount : completed,
                status = ((amount || 0) * 100) + '%',
                lines;

              lines = [{
                value: point.name,
                style: 'font-weight: bold;'
              }, {
                title: this.$t('reports.state'),
                value: options.state
              }, {
                title: this.$t('reports.begin'),
                value: dateFormat(format, point.start)
              }, {
                visible: !options.milestone,
                title: this.$t('reports.end'),
                value: dateFormat(format, point.end)
              }, {
                title: this.$t('reports.author'),
                value: options.owner || 'unassigned'
              }];

              return reduce(lines, function (str, line) {
                var s = '',
                  style = (
                    defined(line.style) ? line.style : 'font-size: 0.8em;'
                  );
                if (line.visible !== false) {
                  s = (
                    '<span style="' + style + '">' +
                    (defined(line.title) ? line.title + ': ' : '') +
                    (defined(line.value) ? line.value : '') +
                    '</span><br/>'
                  );
                }
                return str + s;
              }, '');
            }
          },
          title: false,
          xAxis: {
            currentDateIndicator: true,
          }
        })
      }
    },
    mounted() {
      this.$store.commit('Reports/CLEAR', 'employeeGanttData')
      this.loadData()
    },
    computed: {
      ...mapState('Account', ['account']),
      ...mapState('Reports', ['employeeGanttData']),
      ...mapGetters('Reports', ['employeeGantt']),
      employee() {
        return this.employeeId ? this.employeeId : this.account.employee.id
      },
      breadcrumbs() {
        return [
          {name: 'reportsList', path: 'reportsList'},
          {name: 'userReport'}
        ]
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>